import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/funnels")({
  component: lazyRouteComponent(() => import("./-pages/admin.funnels")),
  head: () => ({
    meta: [
      { title: "مراقب القمعات · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
